module.exports = "/_next/static/images/humbaur-logo-52d0cf17ee10480ca81fca1d5d68ecb1.svg";